import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Features } from 'projects/Widget/src/app/business-entities/step.class';
import { Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { CheckInUsersModel } from '../../../business-entities/checkin-user-model';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { Filter } from '../../../business-entities/Filter';
import { PagerData } from '../../../business-entities/PagerData';
import { DashboardService } from '../../../business-services/dashboard.service';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { PaginationService } from '../../../services/pagination.service';
import { SettingService } from '../../../business-services/setting.service';
import { CheckinUserService } from './../../../business-services/checkin-user.service';
import { CheckinDealerDetailsComponent } from './checkin-dealer-details/checkin-dealer-details.component';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Component({
  selector: 'app-checkin-user',
  templateUrl: './checkin-user.component.html',
  styleUrls: ['./checkin-user.component.css'],
})
export class CheckinUserComponent implements OnInit {
  dropdownSettings: {};
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: this.globalSetting.getFullDateFormat(),
    customTodayClass: 'custom-today-class'
  });

  checkInUserList: CheckInUsersModel[];
  dealerList: UserDealersModel[] = [];
  selectedDealers: { dealerId: string}[] = [];
  selectedDate: any[] = [];
  totalCount: number = 0;
  scrollDistance = 1;
  throttle = 100;

  pagerData: PagerData = {
    page: 1,
    pagerSize: 25,
  };
  pager: any = {};
  pagedItems: any[];
  dataRows: any[] = [];
  filterItems: any[];
  filter: Filter = new Filter();
  dataList :CheckInUsersModel []=[];
  isShowLocationCode : boolean = false;
  features: Features[] = [];
  subscription : Subscription;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  CheckInUsageReport = Enums.CheckInUsageReport;
  CheckInUsageReportStatus=Enums.CheckInUsageReportStatus;

  constructor(
    private spinner: NgxSpinnerService,
    private dashboardService: DashboardService,
    private userService: UserDataService,
    private datePipe: DatePipe,
    private checkInUserService: CheckinUserService,
    private pagerService: PaginationService,
    private modalService: NgbModal,
    public translate: TranslateService,
    private toaster: ToastrService,
    private cdr:ChangeDetectorRef,
    private excelService: ExcelService,
    private currentLanguageService: CurrentLanguage,
    private secureStorage: SecureStorage,
    private readonly dealerService: DealerBusinessService,
    private readonly globalSetting: GlobalSetting,
    private readonly settingService: SettingService
  ) {}

  ngOnInit() {
    this.checkInUserService.checkinUserListRequest.startRecordNumber = 0;
    this.getFeatures();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'dealerId',
      textField: 'dealerName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight: 500,
    };
    this.userService.currentUser.subscribe((resUser) => {
      resUser && this.GetDealers(resUser.userId);
    });
    this.setTodayDate()
    this.checkInUserList = [];
  }

  setTodayDate(){
    let todayDate = new Date();
    let formattedTodayDate = this.datePipe.transform(todayDate, 'dd/MM/yyyy');
    this.selectedDate=[];
    this.selectedDate.push(todayDate);
    this.selectedDate.push(todayDate);
    let formatted= formattedTodayDate + ' - ' + formattedTodayDate;
    this.checkInUserService.checkinUserListRequest.selectedDate = formatted;
  }

  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features == null || this.features == undefined) {
      this.subscription = this.currentLanguageService.featureList.subscribe((res) => {
        this.features = res;
        if (this.features?.length > 0) {
          this.setFeatureData();
        }
      })
    }
    else {
      this.setFeatureData();
    }
  }
  setFeatureData() {
    this.isShowLocationCode=this.features.find(x => x.featureCode === Enums.FeatureCode.ShowLocationCode)?.isActive;
  }

  async GetDealers(userId:string) {
    this.spinner.show();
    const allDealers = await this.dashboardService.GetDealers(userId);
    
      // Fetch all settings
      const settingsResponse = await this.settingService.GetSettings();
      
      // Find DealersForSMS setting
      if (settingsResponse && settingsResponse.responseObject) {
        const dealersForSMSSetting = settingsResponse.responseObject.find(
          (setting: any) => setting.property === 'DealersForSMS'
        );
        
        if (dealersForSMSSetting && dealersForSMSSetting.value) {
          const dealerIdsString = dealersForSMSSetting.value.toString().trim();
          
          if (dealerIdsString) {
            // Handle single or comma-separated dealer IDs
            const allowedDealerIds = dealerIdsString.includes(',') 
              ? dealerIdsString.split(',').map((id: string) => id.trim()).filter((id: string) => id)
              : [dealerIdsString];
            
            // Filter dealers by allowed IDs
            this.dealerList = allDealers.filter(dealer => 
              allowedDealerIds.includes(dealer.dealerId)
            );
          } else {
            this.dealerList = allDealers;
          }
        } else {
          // DealersForSMS setting not found, show all dealers
          this.dealerList = allDealers;
        }
      } else {
        this.dealerList = allDealers;
      }
    
    // Set default dealer selection after dealer list is loaded
    const defaultDealerId = this.userService.currentUserValue.defaultDealerId;
    if (defaultDealerId && this.dealerList) {
      const defaultDealer = this.dealerList.find(
        (dealer) => dealer.dealerId === defaultDealerId
      );
      if (defaultDealer) {
        this.selectedDealers = [defaultDealer];
        // Update the service with the selected dealer
        this.checkInUserService.checkinUserListRequest.selectedDealers = [
          defaultDealerId,
        ];
      }
    }
    this.spinner.hide();
  }

  async getCheckInUserList() {
    this.checkInUserList=[];
    this.spinner.show();
    await this.checkInUserService
      .getCheckInUserList(this.checkInUserService.checkinUserListRequest)
      .then(
        (response) => {
          this.spinner.hide();
        const formattedData = response.responseObject.map((item: any) => ({
          ...item,
        }));
        this.checkInUserList.push(...formattedData);
          if (response.responseObject?.result?.errorCode == '5449') {
            this.totalCount = 0;
          } else {
            this.totalCount =
              this.checkInUserList.length > 0
                ? this.checkInUserList?.length
                : 0;
          }
          this.resetPagerData(
            this.supplierInitiliseGridFromServer(
              this.checkInUserList,
              this.totalCount
            )
          );
          if (this.pagerData.page > 1) {
            this.resetPagerData(
              this.initilisePagerFromServer(
                this.pagerData.page,
                this.pagerData.pagerSize,
                this.totalCount
              )
            );
          }
        },
        (_error) => {
          this.spinner.hide();
        }
      )
      .finally(() => this.spinner.hide());
  }

  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }

  onRefreshClick(){
    this.checkInUserList = [];
    this.getCheckInUserList();
  }

 onDateRangeChanged(event: any) {
  this.selectedDate = (typeof event === 'undefined') ? [] : event;
  if (!this.selectedDate || this.selectedDate.length < 2) {
    this.onDateSelectionCleared();
    return;
  }

  const startDate = new Date(this.selectedDate[0]);
  const endDate = new Date(this.selectedDate[1]);
  const diffInTime = endDate.getTime() - startDate.getTime();
  const diffInDays = diffInTime / (1000 * 3600 * 24);
 
  if (diffInDays > Number(EnvSetting.CheckInUsageReportDays)) {
   let warningMessage = this.translate.instant("lblMonthDateRange");
   warningMessage = warningMessage.replace('{Day}', EnvSetting.CheckInUsageReportDays);
    this.toaster.warning(warningMessage);
    this.setTodayDate();
    this.getCheckInUserList();
    return;
  }

  let selectedDateFormatted = this.getFormattedDate(this.selectedDate);
  this.checkInUserList = [];

  if (this.selectedDealers?.length > 0) {
    let dealers = [];
    dealers = this.selectedDealers.map(x => x.dealerId);
    this.checkInUserService.checkinUserListRequest.selectedDealers = dealers;
  }

  if (selectedDateFormatted == "") {
    this.onDateSelectionCleared();
  }

  this.checkInUserService.checkinUserListRequest.selectedDate = selectedDateFormatted;
  this.getCheckInUserList();
}

  onDateSelectionCleared(){
    let warningmsg = this.translate.instant("lblShowingLastMonthData");
    this.toaster.warning(warningmsg);      
    var date = new Date();
    let startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    let formattedStartDate = this.datePipe.transform(startDate, 'dd/MM/yyyy');
    let endDate = new Date();
    let formattedEndDate = this.datePipe.transform(endDate, 'dd/MM/yyyy');
    this.selectedDate=[];
    this.selectedDate.push(startDate);
    this.selectedDate.push(endDate);
    this.cdr.detectChanges();
  }

  onChangeDealer(dealer: any): void {
    this.checkInUserList = [];
    let dealers = [];
    if(this.selectedDealers?.length > 0){
      dealers = this.selectedDealers.map(x=> x.dealerId)
    }

    this.checkInUserService.checkinUserListRequest.selectedDealers = dealers;
    this.getCheckInUserList();
  }

  onClearFilter() {
    this.checkInUserList = [];
    this.checkInUserService.checkinUserListRequest.sortColumn = "";
    this.checkInUserService.checkinUserListRequest.sortDirection = "";
    this.checkInUserService.checkinUserListRequest.selectedDealers = [];
    this.selectedDealers = [];
    this.onDateSelectionCleared();
    let selectedDateFormatted= this.getFormattedDate(this.selectedDate);
    this.checkInUserService.checkinUserListRequest.selectedDate = selectedDateFormatted;
  }

  onScrollDown() {
    if (this.totalCount > this.checkInUserList?.length) {
      this.checkInUserService.checkinUserListRequest.startRecordNumber = this.checkInUserList.length
      this.getCheckInUserList();
    }
  }

  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.checkInUserService.checkinUserListRequest.sortColumn = column;
    this.checkInUserService.checkinUserListRequest.sortDirection = direction;
    this.checkInUserService.checkinUserListRequest.startRecordNumber = 0;
    this.checkInUserList = [];
    this.getCheckInUserList();
  }

  onView(item, usageTypeStatus, usageType) {    
    const modalref = this.modalService.open(CheckinDealerDetailsComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.dealerId = item.dealerId;
    modalref.componentInstance.dealerName = item.dealerName;
    modalref.componentInstance.selectedDate = this.checkInUserService.checkinUserListRequest.selectedDate;
    modalref.componentInstance.checkInUsageReportStatus=usageTypeStatus;
    modalref.componentInstance.appointmentCheckInStatus=usageType;
    modalref.result.then((response) => {
      this.onRefreshClick();
  });
  }
  // Export functionality

  public async exportAsXLSX() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const excelData = this.mapDataForExport();
    this.spinner.hide();
    this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblCheckInUsage')}`);
  }

  public async exportAsPDF() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const pdfData = this.mapDataForExport();
    const doc = new jsPDF('landscape');
    autoTable(doc, {
      head: [this.getHeadersForExport()],
      body: pdfData.map(row => Object.values(row)),
      margin: { top: 10, left: 10, right: 10, bottom: 10 },
      styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak' },
      headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold' },
      columnStyles: {
        0: { cellWidth: 15, halign: 'center' },
        1: { cellWidth: 60, halign: 'left' },
        2: { cellWidth: 30, halign: 'right' },
        3: { cellWidth: 25, halign: 'right' },
        4: { cellWidth: 30, halign: 'right' },
        5: { cellWidth: 30, halign: 'right' },
        6: { cellWidth: 35, halign: 'right' },
        7: { cellWidth: 30, halign: 'right' },
        8: { cellWidth: 25, halign: 'right' },
      },
    });
    doc.save(`${this.translate.instant('lblCheckInUsage')}.pdf`);
    this.spinner.hide();
  }

  private async exportData(): Promise<void> {
    this.spinner.show();
    this.checkInUserService.checkinUserListRequest.isExport = true;
    await this.checkInUserService.getCheckInUserList(this.checkInUserService.checkinUserListRequest).then((res) => {
      if (!res || res.responseObject.length === 0) {
        this.toaster.error(this.translate.instant('lblDataNotAvailable'));
        this.dataList = [];
        return;
      }
      this.dataList = res.responseObject;
    }).finally(() => {
      this.checkInUserService.checkinUserListRequest.isExport = false;
      this.spinner.hide();
    })
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblDealerName')]: item.dealerName,
      [this.translate.instant('lblTotalAppointments')]: item.totalAppointment,
      [this.translate.instant('lblSmsSent')]: item.smsSent,
      [this.translate.instant('lblSMSNotSent')]:item.smsNotSent,
      [this.translate.instant('lblCheckInCompletedWithoutSms')]:item.checkInCompletedWithoutSms,
      [this.translate.instant('lblCheckInCompleted')]: item.checkInCompleted,
      [this.translate.instant('lblCheckInNotCompleted')]: item.checkInNotCompleted,
      [this.translate.instant('lblCheckInNotStarted')]: item.checkInNotStarted,
      [this.translate.instant('lblCheckInPercentage')]: `${item.checkInPercentage}%`
    }));
  }

  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblDealerName'),
      this.translate.instant('lblTotalAppointments'),
      this.translate.instant('lblSmsSent'),
      this.translate.instant('lblSMSNotSent'),
      this.translate.instant('lblCheckInCompletedWithoutSms'),
      this.translate.instant('lblCheckInCompleted'),
      this.translate.instant('lblCheckInNotCompleted'),
      this.translate.instant('lblCheckInNotStarted'),
      this.translate.instant('lblCheckInPercentage'),
    ];
  }
  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}
